import React, { useState, useEffect } from "react";
import './Header.css';
import { useNavigate } from 'react-router-dom';

export default function Header() {
    const navigate = useNavigate();

    // Estados
    const [isScrolled, setIsScrolled] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    // Detectar scroll para cambiar el fondo del header
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const goToSection = (hash) => {
        navigate('/');
        setIsMobileMenuOpen(false);
        setActiveDropdown(null);
        setTimeout(() => {
            const section = document.getElementById(hash);
            if (section) {
                section.scrollIntoView({ behavior: "smooth" });
            }
        }, 100);
    };

    const goToPage = (path) => {
        navigate(path);
        setIsMobileMenuOpen(false);
        setActiveDropdown(null);
    };

    // Funciones para manejar menús desplegables
    const handleMouseEnter = (menu) => setActiveDropdown(menu);
    const handleMouseLeave = () => setActiveDropdown(null);
    const toggleDropdown = (menu, e) => {
        e.stopPropagation();
        setActiveDropdown(activeDropdown === menu ? null : menu);
    };

    return (
        <header className={`nav ${isScrolled ? 'solid' : ''}`}>
            {/* LOGO */}
            <div className="nav-logo" onClick={() => goToSection('home')}>
                {/* Si tienes una versión blanca y una azul del logo, colócalas aquí.
                    Si solo tienes una, puedes usar la misma en ambos img */}
                <img className="logo-w" src="/assets/logo-sin-fondo.webp" alt="Logo Navi" />
                <img className="logo-b" src="/assets/logo-sin-fondo.webp" alt="Logo Navi" />
            </div>

            {/* BOTÓN HAMBURGUESA (MÓVIL) */}
            <button
                className={`mobile-toggle ${isMobileMenuOpen ? 'open' : ''}`}
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
                <span></span>
                <span></span>
                <span></span>
            </button>

            {/* MENÚ DE NAVEGACIÓN */}
            <nav className={`nav-center ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
                <div className="nav-item">
                    <button className="nav-link" onClick={() => goToSection('nosotros')}>Nosotros</button>
                </div>
                <div className="nav-item">
                    <button className="nav-link" onClick={() => goToSection('contacto')}>Contacto</button>
                </div>
                <div className="nav-item">
                    <button className="nav-link" onClick={() => goToPage('/blog')}>Blog</button>
                </div>

                {/* DROPDOWN PORTFOLIO */}
                <div
                    className="nav-item"
                    onMouseEnter={() => handleMouseEnter('portfolio')}
                    onMouseLeave={handleMouseLeave}
                >
                    <button className="nav-link" onClick={(e) => toggleDropdown('portfolio', e)}>
                        Portfolio
                        <svg viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>

                    <div className={`nav-dd ${activeDropdown === 'portfolio' ? 'show' : ''}`}>
                        <button onClick={() => goToPage('/portfolio/mantenimiento-predictivo')}>
                            <div className="nav-dd-dot"></div> Mantenimiento predictivo
                        </button>
                        <button onClick={() => goToPage('/portfolio/orquestador-multi-agente')}>
                            <div className="nav-dd-dot"></div> Orquestador multi-agente
                        </button>
                        <button onClick={() => goToPage('/portfolio/cerebro-documental')}>
                            <div className="nav-dd-dot"></div> Cerebro documental
                        </button>
                        <button onClick={() => goToPage('/portfolio/conectividad-legacy')}>
                            <div className="nav-dd-dot"></div> Conectividad Legacy
                        </button>
                    </div>
                </div>

                {/* DROPDOWN DEMOS */}
                <div
                    className="nav-item"
                    onMouseEnter={() => handleMouseEnter('demos')}
                    onMouseLeave={handleMouseLeave}
                >
                    <button className="nav-link" onClick={(e) => toggleDropdown('demos', e)}>
                        Demos
                        <svg viewBox="0 0 12 12" fill="none"><path d="M2 4l4 4 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
                    </button>

                    <div className={`nav-dd ${activeDropdown === 'demos' ? 'show' : ''}`}>
                        <button onClick={() => goToPage('/demos/inmobiliarias')}>
                            <div className="nav-dd-dot"></div> Demo Inmobiliarias
                        </button>
                    </div>
                </div>

                {/* CTA MÓVIL (Visible solo en menú hamburguesa) */}
                <a
                    className="nav-btn mobile-cta"
                    href="https://wa.me/34624118531?text=%C2%A1Hola..."
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    SABER MÁS
                </a>
            </nav>

            {/* CTA DESKTOP */}
            <a
                className="nav-btn desktop-cta"
                href="https://wa.me/34624118531?text=%C2%A1Hola..."
                target="_blank"
                rel="noopener noreferrer"
            >
                SABER MÁS
            </a>
        </header>
    );
}